import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

const WrenchIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.91188 1.18509C5.73336 0.00655735 4.01053 -0.292218 2.55414 0.285414L5.34052 3.07182C5.49454 3.22564 5.49414 3.47709 5.34012 3.63111L3.6309 5.34034C3.47708 5.49377 3.22505 5.49456 3.07162 5.34093L0.285238 2.55433C-0.292192 4.01074 0.006778 5.73378 1.18491 6.91172C2.20448 7.9317 3.63228 8.28984 4.94215 7.99402L10.3157 13.368C11.1584 14.2107 12.5249 14.2107 13.3675 13.3676C14.2108 12.525 14.2108 11.1587 13.3675 10.3154C13.3666 10.3146 13.3658 10.3138 13.3648 10.313L7.99457 4.94237C8.28979 3.6321 7.93146 2.20448 6.91188 1.18509ZM12.5984 12.5987C12.1803 13.0162 11.5031 13.0162 11.085 12.5983C10.6677 12.1804 10.6674 11.5032 11.085 11.0853C11.5031 10.6678 12.1803 10.667 12.5984 11.0853C13.0163 11.5032 13.0161 12.1802 12.5984 12.5987Z"
      fill="#7D858C"
    />
  </SvgIcon>
);

export default WrenchIcon;
